import type { ButtonHTMLAttributes } from 'react';
import { cn } from './cn';

export interface ChipProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Shows the chip as chosen (accent outline). Pair with aria-pressed when it toggles. */
  selected?: boolean;
  /** A suggestion the user hasn't taken yet: dashed amber outline (v0.1.1). */
  suggested?: boolean;
}

/** Small pill button (44px tall touch target) for categories, suggestions and range presets. */
export function Chip({
  selected = false,
  suggested = false,
  className,
  type = 'button',
  ...rest
}: ChipProps) {
  return (
    <button
      type={type}
      className={cn(
        'inline-flex min-h-11 shrink-0 items-center gap-1 whitespace-nowrap rounded-full border px-4 text-sm',
        'motion-safe:transition-transform motion-safe:duration-100 motion-safe:active:scale-[0.98]',
        'enabled:hover:border-border disabled:opacity-50',
        selected
          ? 'border-accent bg-secondary text-fg'
          : suggested
            ? 'border-dashed border-accent bg-surface text-fg'
            : 'border-divider bg-surface text-fg',
        className,
      )}
      {...rest}
    />
  );
}
